import axios from 'redaxios';
import { HOST } from '../constans/api';

const http = axios.create({
    baseURL: HOST,
    // timeout: 1000,
  });

export {http}